import React, { useState, useEffect } from 'react';
import './PlaceholderPage.css';
import { MDBRow, MDBCol, MDBInput, MDBBtn } from 'mdb-react-ui-kit';

const ShopifySettingsPage = () => {

  const [metafields, setMetafields] = useState([]);
  const [newField, setNewField] = useState({ key: '', value: '' });

  // 🔹 Dummy backend simulation
  useEffect(() => {
    setMetafields([
      { key: 'color', value: 'red' },
      { key: 'size', value: 'M' },
    ]);
  }, []);

  const handleFieldChange = (index, field, value) => {
    setMetafields(prev => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addMetafield = () => {
    if (!newField.key.trim()) return;
    setMetafields(prev => [...prev, { ...newField }]);
    setNewField({ key: '', value: '' });
  };

  const removeMetafield = (index) => {
    setMetafields(prev => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    console.log('Saved Metafields:', metafields);
    alert('Metafields saved (simulated)');
  };

  return (
    <div className="placeholder-page">
      <h1 className="page-title">Shopify Settings</h1>
      <p className="page-description">
        Configure Shopify settings including custom metafields for customers.
      </p>

      <div className="settings-card">
        <h4 className="section-title">Custom Metafields</h4>

        <MDBRow className="mb-3">
          <MDBCol md="5">
            <MDBInput
              label="Key"
              size="lg"
              value={newField.key}
              onChange={(e) => setNewField(prev => ({ ...prev, key: e.target.value }))}
            />
          </MDBCol>
          <MDBCol md="5">
            <MDBInput
              label="Value"
              size="lg"
              value={newField.value}
              onChange={(e) => setNewField(prev => ({ ...prev, value: e.target.value }))}
            />
          </MDBCol>
          <MDBCol md="2">
            <MDBBtn color="primary" size="lg" onClick={addMetafield}>
              Add
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div className="metafields-list">
          {metafields.map((field, index) => (
            <MDBRow key={index} className="mb-2 align-items-center">
              <MDBCol md="5">
                <MDBInput
                  label="Key"
                  size="lg"
                  value={field.key}
                  onChange={(e) => handleFieldChange(index, 'key', e.target.value)}
                />
              </MDBCol>
              <MDBCol md="5">
                <MDBInput
                  label="Value"
                  size="lg"
                  value={field.value}
                  onChange={(e) => handleFieldChange(index, 'value', e.target.value)}
                />
              </MDBCol>
              <MDBCol md="2">
                <MDBBtn color="danger" size="lg" onClick={() => removeMetafield(index)}>
                  Remove
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          ))}
        </div>

        <div className="save-wrapper mt-4">
          <MDBBtn color="success" size="lg" onClick={handleSave}>
            Save Metafields
          </MDBBtn>
        </div>
      </div>
    </div>
  );
};

export default ShopifySettingsPage;
